import styled from '@emotion/styled'
import { useBreakpoint, useLanguage } from '@pharmac-extranet/shared'
import { PharmacButton, PharmacIcon, PharmacRow, PharmacText } from '@pharmac/ui'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useUserCustomerDetails } from '../../features/customer/useUserCustomerDetails'
import { useExtranetPath } from '../../router/useExtranetPath'
import { AddCustomerUser } from './AddCustomerUser'
import { CustomerUserListMobileTable } from './CustomerUserListMobileTable'
import { CustomerUserListTable } from './CustomerUserListTable'

const ButtonRow = styled(PharmacRow)`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-bottom: var(--spacing-medium);
`

export const CustomerUserList = () => {
  const { t } = useLanguage(['extranet', 'common'])
  const { minDesktop } = useBreakpoint()
  const { customerUsers } = useUserCustomerDetails()
  const navigate = useNavigate()
  const createLink = useExtranetPath()
  const { id } = useParams()
  const [addUser, setAddUser] = useState<boolean>(false)

  return (
    <>
      {addUser && <AddCustomerUser setShow={() => setAddUser(false)} />}
      {!id && customerUsers && !addUser && (
        <>
          <ButtonRow>
            <PharmacButton
              size="small"
              marginMediumRight
              onClick={() => setAddUser(true)}
            >
              <PharmacIcon icon="plus" />
              <PharmacText
                paddingSmallLeft
                weight="bold"
                paddingSmallRight
              >
                {t('customer.addUser')}
              </PharmacText>
            </PharmacButton>
            <PharmacButton
              paddingSmallRight
              size="small"
              variant="secondary"
              onClick={() => navigate(createLink('oma-annos.customership.inviteLinks'))}
            >
              <PharmacText
                paddingSmallLeft
                paddingSmallRight
                weight="bold"
              >
                {t('customer.inviteLinks')}
              </PharmacText>
            </PharmacButton>
          </ButtonRow>
          {minDesktop ? (
            <CustomerUserListTable customerUsers={customerUsers} />
          ) : (
            <CustomerUserListMobileTable customerUsers={customerUsers} />
          )}
        </>
      )}
    </>
  )
}
